import React, { useEffect, useState } from 'react';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import useFetch from 'use-http';

const ZoomComponent = ({
	src,
	alt = '',
	width = 'auto',
	height = '50px',
}: {
	src: string;
	alt?: string;
	width?: string;
	height?: string;
}) => {
	const [blobUrl, setBlobUrl] = useState<string>('');
	const { get } = useFetch({ responseType: 'blob' });

	useEffect(() => {
		// Не загружаем если src пустой или невалидный
		if (!src || src.trim() === '') return;

		let objectUrl: string | null = null;

		const loadImage = async () => {
			try {
				const blob = await get(src);

				if (blob) {
					// Проверяем не JSON ли это (ошибка с бэкенда)
					if (blob.type === 'application/json') {
						const text = await blob.text();
						console.warn('File not found in S3:', text);
						return;
					}

					objectUrl = URL.createObjectURL(blob);
					setBlobUrl(objectUrl);
				}
			} catch (err) {
				console.error('Error loading image from S3:', src, err);
			}
		};

		loadImage();

		// Cleanup: освобождаем blob URL при размонтировании
		return () => {
			if (objectUrl) {
				URL.revokeObjectURL(objectUrl);
			}
		};
	}, [src, get]);

	// Если src пустой, не показываем компонент
	if (!src) {
		return null;
	}

	// Если файл не загружен (loading или ошибка), не показываем компонент
	// Это предотвращает мерцание заглушки
	if (!blobUrl) {
		return null;
	}

	return (
		<Zoom transitionDuration={10} zoomMargin={20}>
			<img alt={alt} src={blobUrl} width={width} className="img" style={{ maxHeight: height }} />
		</Zoom>
	);
};

export default ZoomComponent;
